import { render, staticRenderFns } from "./strokeOrder.vue?vue&type=template&id=f1e4b488&scoped=true&"
import script from "./strokeOrder.vue?vue&type=script&lang=js&"
export * from "./strokeOrder.vue?vue&type=script&lang=js&"
import style0 from "./strokeOrder.vue?vue&type=style&index=0&id=f1e4b488&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e4b488",
  null
  
)

export default component.exports